module.exports = __webpack_public_path__ + "img/help.8afa0835.png";